//initial redux
import { all } from "redux-saga/effects";

const initialState = {
	importStatus: null,
	showStackTrace: false,
};

/////////
//types
export const types = {
	TOGGLE_STACK_TRACE: "screens/MasterRules/Import/Status/Overview/TOGGLE_SHOW_STACK_TRACE",
};

///////////
//reducers
export const reducers = {
	reducer(state = initialState, action) {
		switch (action.type) {
			case types.TOGGLE_STACK_TRACE:
				return { ...state, showStackTrace: !state.showStackTrace };
			default:
				return state;
		}
	}
};

//////////
//sagas
export const sagas = {
	*rootSaga() {
		yield all([]);
	},

};

////////
//actions
export const actions = {

	toggleStackTrace() {
		return {
			type: types.TOGGLE_STACK_TRACE,
			payload: null,
		}
	}

};



// WEBPACK FOOTER //
// ./src/ui/ImportOverview/ImportStatus/ImportStatusOverview/redux.js